import type { FC, PropsWithChildren } from "react";
import { createContext } from "react";

type DirectusContextValue = { url: string };

// eslint-disable-next-line react-refresh/only-export-components
export const directusContext = createContext<DirectusContextValue | null>(null);
export const DirectusProvider: FC<PropsWithChildren<DirectusContextValue>> = ({
  children,
  url,
}) => {
  return (
    <directusContext.Provider value={{ url }}>
      {children}
    </directusContext.Provider>
  );
};
